export default __webpack_public_path__ + "Mask-group-11.8e661b.svg";